import { t } from 'i18next'

import { EQUIPMENT_QUALITY_CATEGORIES_MAP, EQUIPMENT_STATUSES } from '_constants/equipments'

export const BADGE_LABEL_MAP = {
  crown: t('checkIn:equipments.assignToEquipment.gold'),
  diamond: t('checkIn:equipments.assignToEquipment.diamond'),
  award: t('checkIn:equipments.assignToEquipment.silver'),
  shield: t('checkIn:equipments.assignToEquipment.platinum'),
}

export const BADGE_COLOR_MAP = {
  [EQUIPMENT_QUALITY_CATEGORIES_MAP.silver.value]: 'gray.40',
  [EQUIPMENT_QUALITY_CATEGORIES_MAP.gold.value]: 'warning.main',
  [EQUIPMENT_QUALITY_CATEGORIES_MAP.platinum.value]: 'gray.64',
  [EQUIPMENT_QUALITY_CATEGORIES_MAP.diamond.value]: 'blue.dark',
}

export const BADGE_BACKGROUND_COLOR_MAP = {
  [EQUIPMENT_QUALITY_CATEGORIES_MAP.silver.value]: 'gray.8',
  [EQUIPMENT_QUALITY_CATEGORIES_MAP.gold.value]: 'warning.lightest',
  [EQUIPMENT_QUALITY_CATEGORIES_MAP.platinum.value]: 'gray.3',
  [EQUIPMENT_QUALITY_CATEGORIES_MAP.diamond.value]: 'blue.lightest',
}

export const STATUS_I18N_KEY_MAP = {
  [EQUIPMENT_STATUSES.SELECTED]: 'selected',
  [EQUIPMENT_STATUSES.AVAILABLE]: 'available',
  [EQUIPMENT_STATUSES.IN_USE]: 'inUse',
  [EQUIPMENT_STATUSES.DIRTY]: 'dirty',
  [EQUIPMENT_STATUSES.ERROR]: 'unavailable',
  [EQUIPMENT_STATUSES.DISABLED]: 'unavailable',
  [EQUIPMENT_STATUSES.DELAY]: 'delay',
  FINISHING: 'finishing',
}

export const BORDER_COLOR_BY_STATUS = {
  [EQUIPMENT_STATUSES.SELECTED]: 'secondary.main',
  [EQUIPMENT_STATUSES.AVAILABLE]: 'success.main',
  [EQUIPMENT_STATUSES.DELAY]: 'blue.dark',
  [EQUIPMENT_STATUSES.IN_USE]: 'blue.dark',
  [EQUIPMENT_STATUSES.DIRTY]: 'warning.main',
  [EQUIPMENT_STATUSES.ERROR]: 'error.main',
  [EQUIPMENT_STATUSES.DISABLED]: 'error.main',
}

// Mock data generator function
const generateMockEquipment = (id) => {
  const statuses = [
    EQUIPMENT_STATUSES.AVAILABLE,
    EQUIPMENT_STATUSES.IN_USE,
    EQUIPMENT_STATUSES.DIRTY,
    EQUIPMENT_STATUSES.DELAY,
    EQUIPMENT_STATUSES.ERROR,
  ]
  const qualityCategories = ['silver', 'gold', 'diamond', 'platinum']
  const categories = ['UV', 'REGULAR']

  const status = statuses[Math.floor(Math.random() * statuses.length)]
  const qualityCategory = qualityCategories[Math.floor(Math.random() * qualityCategories.length)]

  return {
    id: id.toString(),
    name: `Equipment ${id}`,
    image: `https://picsum.photos/seed/eq${id}/200/120`,
    status,
    qualityCategory,
    category: categories[Math.floor(Math.random() * categories.length)],
    queue:
      status === EQUIPMENT_STATUSES.IN_USE || status === EQUIPMENT_STATUSES.DELAY
        ? Array.from({ length: Math.floor(Math.random() * 3) }, (_, i) => ({
            id: `queue-${id}-${i}`,
          }))
        : [],
    assignments:
      status === EQUIPMENT_STATUSES.IN_USE || status === EQUIPMENT_STATUSES.DELAY
        ? [
            {
              id: `assignment-${id}`,
              createdAt: new Date(Date.now() - Math.random() * 30 * 60 * 1000).toISOString(), // Random time up to 30 min ago
              timerMinutes: 15 + Math.floor(Math.random() * 15), // 15-30 minutes
              delayMinutes: Math.floor(Math.random() * 5), // 0-5 minutes delay
            },
          ]
        : [],
  }
}

export const EQUIPMENTS_MOCK = Array.from({ length: 32 }, (_, i) => generateMockEquipment(i + 1))
